import { PageBlock } from "@/shared/pageComposition/BlockList";

import { EmptyPlanBlock } from "./blocks/EmptyPlanBlock";
import { PlanContentBlock } from "./blocks/PlanContentBlock";
import { PlanTabsBlock } from "./blocks/PlanTabsBlock";
import { InfoTabPlanModel } from "./InfoTabPlan.model";

export const getInfoTabPlanBlocks = (
    model: InfoTabPlanModel,
): PageBlock<InfoTabPlanModel>[] => [
    {
        key: "empty-plan",
        order: 10,
        isVisible: (model) =>
            model.capabilities.canSeePlan &&
            !model.hasPointPlan &&
            !model.hasRoutePlan,
        render: () => <EmptyPlanBlock />,
    },
    {
        key: "plan-tabs",
        order: 20,
        isVisible: (model) =>
            model.capabilities.canSeePlan &&
            (model.hasPointPlan || model.hasRoutePlan),
        render: () => (
            <PlanTabsBlock
                tabs={model.availableTabs}
                activeTab={model.activeTab}
                onTabChange={model.setActiveTab}
            />
        ),
    },
    {
        key: "plan-content",
        order: 30,
        isVisible: (model) =>
            model.capabilities.canSeePlan &&
            (model.hasPointPlan || model.hasRoutePlan),
        render: () => (
            <PlanContentBlock
                activeTab={model.activeTab}
                hasPointPlan={model.hasPointPlan}
                hasRoutePlan={model.hasRoutePlan}
                currentPointPlan={model.currentPointPlan}
                currentRoutePlan={model.currentRoutePlan}
                currentPointFinGroupsFact={model.currentPointFinGroupsFact}
            />
        ),
    },
];
